"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const case_1 = require("case");
const React = __importStar(require("react"));
const Code_1 = __importDefault(require("../Code/Code"));
const styled_1 = __importDefault(require("../utils/styled"));
const DebugJSONViewer = styled_1.default(Code_1.default) `
  color: white;
  max-width: 50vw;
`;
function makeRowsFromConfig(inputValuesProp) {
    return Object.entries(inputValuesProp).map(([key, value]) => {
        const casedKey = case_1.title(key);
        if (value instanceof Object) {
            return (React.createElement(React.Fragment, { key: key },
                React.createElement("tr", null,
                    React.createElement("td", { colSpan: 2 }, casedKey)),
                React.createElement("tr", null,
                    React.createElement("td", { colSpan: 2 },
                        React.createElement(DebugJSONViewer, { codeTheme: {
                                base00: "transparent",
                                base02: "transparent",
                                base04: "cyan",
                                base07: "orange",
                                base09: "white",
                            }, syntax: "json", src: value, children: undefined })))));
        }
        return (React.createElement("tr", { key: key },
            React.createElement("td", null, casedKey),
            React.createElement("td", null, value)));
    });
}
exports.makeRowsFromConfig = makeRowsFromConfig;
//# sourceMappingURL=makeRowsFromConfig.js.map